export default __webpack_public_path__ + "static/media/adit.f6573708.png";